import { render, staticRenderFns } from "./VideoRequests.vue?vue&type=template&id=c0b7a674&"
import script from "./VideoRequests.vue?vue&type=script&lang=ts&"
export * from "./VideoRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports